import { Map } from 'immutable';
import * as relocation from '../../actions/relocation/relocationHousing';

const initialState = Map({
    OCCUPANCYDATECB: false,
    EXPIRYDATECB :false,
    CLAUSECB:false,
    housingValidation:{},
    OCCUPANCYDATE: null,
    EXPIRYDATE:null
});

const actionsMap = {
  [relocation.SAVE_OCCUPANCYDATECB]: (state, action) => {
    return state.set('OCCUPANCYDATECB', action.data);
  },
  [relocation.SAVE_EXPIRYDATECB]: (state, action) => {
    return state.set('EXPIRYDATECB', action.data);
  },
  [relocation.SAVE_CLAUSECB]: (state, action) => {
    return state.set('CLAUSECB', action.data);
  },
  [relocation.SAVE_HOUSINGVALIDATION]: (state, action) => {
    return state.set('housingValidation', action.data);
  },
  [relocation.SAVE_EXPIRYDATE]: (state, action) => {
    return state.set('EXPIRYDATE', action.data);
  },
  [relocation.SAVE_OCCUPANCYDATE]: (state, action) => {
    return state.set('OCCUPANCYDATE', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}